export default "__VITE_ASSET__27f4e3e0__"